import React from "react";
import {
  Combobox,
  Form,
  FormField,
  FormLabel,
  FormControl,
  FormItem,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@repo/ui";
import { Controller } from "react-hook-form";
import { FaAsterisk } from "react-icons/fa";
import { BiInfoCircle } from "react-icons/bi";
import { GitFork } from "lucide-react";
import { Label } from "./label";

export function FormDropdown({
  label,
  name,
  isRequired,
  placeholder,
  rules,
  id,
  text,
  info,
  data,
  disabled,
  errors,
  filterable,
  control,
  onChange,
  dropdownProps,
  controlStyles,
  disablePlaceholderItem,
  detailsView,
  recordsView,
  detailContentClass,
  recordContentClass,
  hideIcons,
}) {
  // console.log(
  //   "data",
  //   data.map((elm) => ({
  //     ...elm,
  //     label: elm[text],
  //     value: elm[id],
  //   })),
  //   name
  // );
  return (
    <FormField
      control={control}
      name={name}
      rules={rules ? { ...rules } : {}}
      render={({ field }) => (
        <FormItem>
          <Label label={label} isRequired={isRequired} />

          <FormControl>
            <div className="flex flex-col react-form-hook-dropdown">
              <div className="flex flex-row items-center gap-[1px]">
                <Combobox
                  {...dropdownProps}
                  disabled={disabled}
                  style={Object.assign(
                    dropdownProps?.style ? dropdownProps.style : {},
                    errors[name] ? { borderColor: "red" } : {}
                  )}
                  className={errors[name] ? "border-red " : ""}
                  value={field.value || null}
                  data={data.map((elm) => ({
                    ...elm,
                    label: elm[text],
                    value: elm[id],
                  }))}
                  placeholder={placeholder}
                  setValue={(res) => {
                    if (disabled) {
                      return;
                    }
                    if (onChange) {
                      if (rules && "validate" in rules) {
                        if (rules.validate(res)) {
                          onChange(res);
                        }
                      } else {
                        onChange(res);
                      }
                    }

                    field.onChange(res);
                  }}
                />
                {hideIcons ? (
                  <></>
                ) : (
                  <>
                    <Dialog
                      onOpenChange={() => {}}
                      style={{ maxWidth: "1400px" }}
                    >
                      <DialogTrigger asChild>
                        <BiInfoCircle
                          title="View Information"
                          fontSize="16px"
                          style={{
                            visibility: detailsView ? "visible" : "hidden",
                            fontSize: "16px",
                            width: "1em",
                            height: "1em",
                            minWidth: "16px",
                            color: "hsl(var(--secondary))",
                          }}
                        />
                      </DialogTrigger>
                      <DialogHeader>
                        <DialogTitle />
                      </DialogHeader>
                      <DialogContent
                        className={detailContentClass}
                        onOpenAutoFocus={(e) => {
                          e.preventDefault();
                        }}
                      >
                        {detailsView || <></>}
                      </DialogContent>
                    </Dialog>
                    <Dialog onOpenChange={() => {}}>
                      <DialogTrigger asChild>
                        <GitFork
                          title="View Records"
                          style={{
                            transform: "rotate(90deg)",
                            visibility: recordsView ? "visible" : "hidden",
                            width: "16px",
                            color: "hsl(var(--secondary))",
                          }}
                        />
                      </DialogTrigger>
                      <DialogHeader>
                        <DialogTitle />
                      </DialogHeader>
                      <DialogContent
                        className={recordContentClass}
                        onOpenAutoFocus={(e) => {
                          e.preventDefault();
                        }}
                      >
                        {recordsView || <></>}
                      </DialogContent>
                    </Dialog>
                  </>
                )}
              </div>

              {info ? (
                <p className="text-black-500 text-xs w-[300px] text-wrap">
                  {info || ""}
                </p>
              ) : (
                <></>
              )}
              {errors ? (
                errors[name] ? (
                  <p className="text-destructive text-xs">
                    {errors[name].message || "Please Select Date!"}
                  </p>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
            </div>
          </FormControl>
        </FormItem>
      )}
    />
  );
}
